import Vue from 'vue'
import Constants from '../../Constants/Constant'

//no token management in this file
export function refreshNotification() {
    let request = self.indexedDB.open('FCM', 2)
    request.onupgradeneeded = function (event) {
        let db = event.target.result
        db.onerror = function (event) {
            console.log(event)
        }
        if (!db.objectStoreNames.contains('notifications')) {
            let os = db.createObjectStore('notifications',
                {keyPath: 'data.notificationId', autoIncrement: true})
        }
    }
    request.onsuccess = function (event) {
        let db = event.target.result
        let tnx = db.transaction('notifications', 'readwrite')
        tnx.onerror = function (event2) {
            console.log('error', event2.target.error)
        }
        let os = tnx.objectStore('notifications')
        let resReq = os.getAll()
        resReq.onsuccess = function () {
            if (resReq.result) {
                Vue.prototype.$totalNotificationCount = resReq.result.length
                let sortedNotifications = resReq.result.sort(function (x, y) {
                    return Number(y.data.notificationTime) -
                        Number(x.data.notificationTime)
                })
                sortedNotifications = sortedNotifications.skip(
                    Vue.prototype.$notificationSkip).limit(Vue.prototype.$notificationLimit)
                Vue.prototype.$allNotifications = sortedNotifications
                Vue.prototype.$unreadNotifications = resReq.result.filter(
                    notification => (notification['status'] === 'UNREAD'))
            } else {
                Vue.prototype.$allNotifications = []
                Vue.prototype.$unreadNotifications = []
            }
        }
    }
}

export function storeNotification(payload) {
    let request = self.indexedDB.open('FCM', 2)
    request.onupgradeneeded = function (event) {
        let db = event.target.result
        if (!db.objectStoreNames.contains('notifications')) {
            let os = db.createObjectStore('notifications',
                {keyPath: 'data.notificationId', autoIncrement: true})
        }
    }
    request.onsuccess = function (event) {
        let db = event.target.result
        let tnx = db.transaction('notifications', 'readwrite')
        tnx.onerror = function (event2) {
            console.log('error', event2.target.error)
        }
        let os = tnx.objectStore('notifications')
        let req = os.add(payload)
        req.onsuccess = function () {
            let resReq = os.getAll()
            resReq.onsuccess = function () {
                if (resReq.result) {
                    Vue.prototype.$totalNotificationCount = resReq.result.length
                    let sortedNotifications = resReq.result.sort(function (x, y) {
                        return Number(y.data.notificationTime) -
                            Number(x.data.notificationTime)
                    })
                    sortedNotifications = sortedNotifications.skip(
                        Vue.prototype.$notificationSkip).limit(Vue.prototype.$notificationLimit)
                    Vue.prototype.$allNotifications = sortedNotifications
                    Vue.prototype.$unreadNotifications = resReq.result.filter(
                        notification => (notification['status'] === 'UNREAD'))
                } else {
                    Vue.prototype.$allNotifications = []
                    Vue.prototype.$unreadNotifications = []
                }
            }
        }
    }
}

export function onNotificationClick(payload) {
    let baseUrl = window.location.origin
    let url = `${baseUrl}#/`
    let redirectUrl
    payload['status'] = 'READ'
    updateNotification(payload)
    if (payload && payload.data && payload.data.notificationType) {
        switch (payload.data.notificationType) {
            case '11': // Stock Transfer
                redirectUrl = `${url}Partners/Purchase?orderId=${payload.data.id}`
                break
            case '22'://Scheme Detail
                redirectUrl = `${url}Partners/Scheme?schemeId=${payload.data.id}`
                break
            case '33':// aniversary, birthdate notification
                localStorage.setItem('currentNotification', JSON.stringify(payload))
                redirectUrl = `POPUP`
                break
            case '44'://custom
                localStorage.setItem('currentNotification', JSON.stringify(payload))
                redirectUrl = `POPUP`
                break
            case '55'://Return Order Detail
                redirectUrl = `${url}ReturnOrders?orderId=${payload.data.id}`
                break
        }
    } else {
        redirectUrl = url
    }
    if (redirectUrl === 'POPUP') {
        // window.open(`${url}Partners/Notifications`, '_self')
    } else {
        window.open(redirectUrl, '_blank')
    }
}

export function updateNotification(payload) {
    let request = self.indexedDB.open('FCM', 2)
    request.onupgradeneeded = function (event) {
        let db = event.target.result
        if (!db.objectStoreNames.contains('notifications')) {
            let os = db.createObjectStore('notifications',
                {keyPath: 'data.notificationId', autoIncrement: true})
        }
    }
    request.onsuccess = function (event) {
        let db = event.target.result
        let tnx = db.transaction('notifications', 'readwrite')
        tnx.onerror = function (event2) {
            console.log('error', event2.target.error)
        }
        let os = tnx.objectStore('notifications')
        let req = os.put(payload)
        req.onsuccess = function () {
            let resReq = os.getAll()
            resReq.onsuccess = function () {
                if (resReq.result) {
                    Vue.prototype.$totalNotificationCount = resReq.result.length
                    let sortedNotifications = resReq.result.sort(function (x, y) {
                        return Number(y.data.notificationTime) -
                            Number(x.data.notificationTime)
                    })
                    sortedNotifications = sortedNotifications.skip(
                        Vue.prototype.$notificationSkip).limit(Vue.prototype.$notificationLimit)
                    Vue.prototype.$allNotifications = sortedNotifications
                    Vue.prototype.$unreadNotifications = resReq.result.filter(
                        notification => (notification['status'] === 'UNREAD'))
                } else {
                    Vue.prototype.$allNotifications = []
                    Vue.prototype.$unreadNotifications = []
                }
            }
        }
    }
}

export function deleteObjectStore() {
    let request = self.indexedDB.open('FCM', 2)
    request.onsuccess = function (event) {
        let db = request.result
        let tnx = db.transaction('notifications', 'readwrite')
        let os = tnx.objectStore('notifications')
        let req = os.clear()
        req.onsuccess = function (event) {
            console.log('cleared')
            refreshNotification()
        }
    }
}

export function loadMoreNotification() {
    let request = self.indexedDB.open('FCM', 2)
    request.onupgradeneeded = function (event) {
        let db = event.target.result
        if (!db.objectStoreNames.contains('notifications')) {
            let os = db.createObjectStore('notifications',
                {keyPath: 'data.notificationId', autoIncrement: true})
        }
    }
    request.onsuccess = function (event) {
        let db = event.target.result
        let tnx = db.transaction('notifications', 'readwrite')
        tnx.onerror = function (event2) {
            console.log('error', event2.target.error)
        }
        let os = tnx.objectStore('notifications')
        let resReq = os.getAll()
        resReq.onsuccess = function () {
            if (resReq.result) {
                Vue.prototype.$totalNotificationCount = resReq.result.length
                let sortedNotifications = resReq.result.sort(function (x, y) {
                    return Number(y.data.notificationTime) -
                        Number(x.data.notificationTime)
                })
                Vue.prototype.$notificationLimit = Vue.prototype.$notificationLimit +
                    Constants.notificationLimitPerBatch
                sortedNotifications = sortedNotifications.skip(
                    Vue.prototype.$notificationSkip).limit(Vue.prototype.$notificationLimit)
                Vue.prototype.$allNotifications = sortedNotifications
                Vue.prototype.$unreadNotifications = resReq.result.filter(
                    notification => (notification['status'] === 'UNREAD'))
            } else {
                Vue.prototype.$allNotifications = []
                Vue.prototype.$unreadNotifications = []
            }
        }
    }
}
